__turbopack_context__.v({
  "className": "noto_sans_gurmukhi_b9e403fa-module__UVovLq__className",
});
